export default __webpack_public_path__ + "static/media/MVIMG_20190507_185613.f76919de.jpg";